import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { getBrand } from '../../utils/getBrand';
import { getEnvironmentType } from '../../init/getAppConfig';
import { EnvType } from '../types/enum';

@Injectable({
  providedIn: 'root',
})
export class PageListService {
  constructor(private http: HttpClient) {}

  loadPageList(): Observable<string[]> {
    return this.http
      .get(`configurations/page-list/${getBrand().name}.json`)
      .pipe(
        map((result: any) =>
          getEnvironmentType() == EnvType.prod ? result.prod : result.npe
        )
      );
  }
}
